<template>
  <section>
    <HomeHeader />
    <HomeAbout />
    <HomeNews />
    <HomePublication />
    <HomeApprendreAgir />
    <HomeWork />
    <HomeCta />
  </section>
</template>

<script>
import * as partials from './partials'

export default {
  name: 'Home',
  components: { ...partials },
  provide() {
    return {
      wp: this.$wp.pages.home || {}
    }
  }
}
</script>
